import { useCallback } from 'react';
import { Mention as MentionPillType } from '../../Room/components/BuyerCopilotChats/MentionsNode/MentionPill';
import {
  MENTION_TOKEN_CAPTURE_REGEX,
  MENTION_TOKEN_SPLIT_REGEX,
} from '../../Room/components/BuyerCopilotChats/MentionsNode/constants';
import { Events } from '../../../enums/Analytics';
import Analytics, { EventProperty } from '../../../tools/Analytics';
import { EVENT_NAMES } from '../constants';

const useCopilotTrackEvents = (
  mentions?: MentionPillType[],
  roomUuid?: string
) =>
  useCallback(
    (eventName: string, eventProperties: EventProperty = {}) => {
      switch (eventName) {
        case EVENT_NAMES.CHAT_QUERY_SENT: {
          let props = { ...eventProperties };
          const rawQuery = props.query_sent;
          const attachedMentions: MentionPillType[] = [];
          const hasMentions =
            typeof rawQuery === 'string' &&
            MENTION_TOKEN_CAPTURE_REGEX.test(rawQuery);
          props = { ...props, content_tagged: !!hasMentions };
          if (hasMentions && mentions?.length) {
            props = {
              ...props,
              query_sent: (rawQuery as string)
                .split(MENTION_TOKEN_SPLIT_REGEX)
                .map((part) => {
                  const match = part.match(MENTION_TOKEN_CAPTURE_REGEX);
                  if (match) {
                    const mention = mentions.find((m) => m.uuid === match[1]);
                    attachedMentions.push(mention!);
                    return mention ? `@${mention.value}` : part;
                  }
                  return part;
                })
                .join(''),
              mentions: JSON.stringify(attachedMentions),
            };
          }
          Analytics.track(Events.BUYER_COPILOT_CHAT_QUERY_SENT, props);
          break;
        }
        case EVENT_NAMES.AI_CHAT_REPLY_COPIED:
          Analytics.track(
            Events.BUYER_COPILOT_AI_CHAT_REPLY_COPIED,
            eventProperties
          );
          break;
        case EVENT_NAMES.AI_CHAT_REPLY_FEEDBACK_SUBMITTED:
          Analytics.track(
            Events.BUYER_COPILOT_AI_CHAT_REPLY_FEEDBACK_SUBMITTED,
            {
              ...eventProperties,
              feedback: eventProperties.helpful ? 'thumbs up' : 'thumbs down',
            }
          );
          break;
        case EVENT_NAMES.ANSWER_MENTIONS_CLICKED:
          Analytics.track(
            Events.BUYER_COPILOT_ANSWER_MENTIONS_CLICKED,
            eventProperties
          );
          break;
        case EVENT_NAMES.CHAT_RESULTS_DISPLAYED_SUCCESSFULLY:
          Analytics.track(
            Events.BUYER_COPILOT_ANSWER_GENERATED,
            eventProperties
          );
          break;
        case EVENT_NAMES.AI_CHAT_PANEL_OPENED:
          Analytics.track(Events.BUYER_COPILOT_LOADED, {
            ...eventProperties,
            room_uuid: roomUuid,
          });
          break;
        case EVENT_NAMES.CHAT_DELETED:
          Analytics.track(
            Events.BUYER_COPILOT_CHAT_HISTORY_CLEARED,
            eventProperties
          );
          break;
        case EVENT_NAMES.ANSWER_GENERATED:
          Analytics.track(
            Events.BUYER_COPILOT_ANSWER_GENERATED,
            eventProperties
          );
          break;
      }
    },
    [mentions, roomUuid]
  );

export { useCopilotTrackEvents };
